import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Margin, Padding, Queue, Stack, Text } from '../../components';
import { BenefitsAndPerksData } from './shared';

const IconWrapper = styled.div`
  height: 20px;
  width: 20px;
`;

const MappedBenefitsAndPerksComponent = (props) => {
  let { startingIndex, endingIndex } = props;
  return (
    <>
      {_.flow(
        (BenefitsAndPerksData) =>
          _.map(BenefitsAndPerksData, (value, index) => {
            return (
              <Queue alignVertical="top" size={5} key={index}>
                <IconWrapper>{value?.icon}</IconWrapper>
                <Stack size={2}>
                  <Text align="left" textType="primary1">
                    {value?.title}
                  </Text>
                  <Text align="left" textType="primary2">
                    {value?.description}
                  </Text>
                </Stack>
              </Queue>
            );
          }),
        (BenefitsAndPerksData) =>
          _.slice(BenefitsAndPerksData, startingIndex, endingIndex)
      )(BenefitsAndPerksData)}
    </>
  );
};

export const BenefitsAndPerksTablet = () => {
  return (
    <Padding size={[7]} backgroundRole="grey2">
      <Stack size={6}>
        <Margin size={[0, 0, 4, 0]}>
          <Text textType="heading3">Benefits & Perks</Text>
        </Margin>
        <Margin size={[0, 8]}>
          <Stack size={5}>
            <MappedBenefitsAndPerksComponent
              columns={5}
              startingIndex={0}
              endingIndex={5}
            />
          </Stack>
        </Margin>
      </Stack>
    </Padding>
  );
};
